var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 27,
    viewBox: "0 0 30 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4446 26.0004V23.2226C20.4446 21.7492 19.8593 20.3361 18.8174 19.2942C17.7755 18.2523 16.3624 17.667 14.889 17.667H6.5556C5.08216 17.667 3.66907 18.2523 2.6272 19.2942C1.58532 20.3361 1 21.7492 1 23.2226V26.0004",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7223 12.1112C13.7906 12.1112 16.2779 9.62387 16.2779 6.5556C16.2779 3.48733 13.7906 1 10.7223 1C7.65407 1 5.16675 3.48733 5.16675 6.5556C5.16675 9.62387 7.65407 12.1112 10.7223 12.1112Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.778 26V23.2222C28.7771 21.9913 28.3674 20.7955 27.6132 19.8226C26.8591 18.8498 25.8032 18.1549 24.6113 17.8472",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4446 1.18018C21.6396 1.48615 22.6988 2.18116 23.4552 3.15562C24.2116 4.13009 24.6222 5.32858 24.6222 6.56216C24.6222 7.79574 24.2116 8.99424 23.4552 9.9687C22.6988 10.9432 21.6396 11.6382 20.4446 11.9441",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.2a03d0c24820f0ba7dbb4b3d9ff6ae9f.svg";
export { ForwardRef as ReactComponent };